import { Select, Text, VStack } from '@genial/components';
import React from 'react';

interface Option {
  label: string;
  value: string;
}

export interface AdvisorSelectProps {
  options: Option[];
  selectedAdvisor?: number;
  disabled: boolean;
  onChange: (advisorId: number) => void;
}

export const AdvisorSelect: React.FC<AdvisorSelectProps> = ({
  options,
  selectedAdvisor,
  disabled,
  onChange,
}) => {
  return (
    <VStack space="inline.xxxs" zIndex={1}>
      <Text variant="semibold">Seleção de Assessor</Text>
      <Select
        maxOptionPerRender={10}
        maxOptionsContentHeight="500px"
        triggerProps={{ bg: 'background' }}
        placeholder="Selecione um Assessor"
        options={options}
        selectedValue={selectedAdvisor?.toString()}
        onValueChange={(value) => onChange(Number(value))}
        disabled={disabled}
      />
    </VStack>
  );
};
